import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <footer className="footer border-t bg-gray-700 h-full">
            <Container>
                <Row>
                    <Col className="text-center py-3">
                        <div className="grid grid-cols-5 py-4 text-center text-white">
                            <div>
                                <h1 className="py-1">About TMK</h1>
                                <Row>
                                    <Link to={"/about/company"} className="py-2 text-sm" id="footer_items"><div>기업소개</div></Link>
                                </Row>
                                <Row>
                                    <Link to={"/about/hiearchy"} className="py-2 text-sm" id="footer_items"><div>조직도</div></Link>                   
                                </Row>
                                <Row>
                                    <Link to={"/about/location"} className="py-2 text-sm" id="footer_items"><div>오시는길</div></Link>  
                                </Row>
                            </div>
                            <div>
                                <h1 className="py-1">Product</h1>
                                <Row>
                                    <Link to={"/products"} className="py-2 text-sm" id="footer_items"><div>품목</div></Link>
                                </Row>
                            </div>
                            <div>
                                <h1 className="py-1">Business Status</h1>
                                <Row>
                                    <Link className="py-2 text-sm" id="footer_items"><div>고객사</div></Link>
                                </Row>
                            </div>
                            <div>
                                <h1 className="py-1">Inquiry</h1>
                                <Row>
                                    <Link to={"/inquiry"} className="py-2 text-sm" id="footer_items"><div>온라인문의</div></Link>
                                </Row>
                            </div>
                            <div>
                                <h1 className="py-1">Languages</h1>
                                <Row>
                                    <Link to={"/inquiry"} className="py-2 text-sm" id="footer_items"><div>English</div></Link>
                                    <Link to={"/inquiry"} className="py-2 text-sm" id="footer_items"><div>한국어</div></Link>
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-center pb-6 text-white border-t pt-4">
                        Copyright &copy; TMK., All Rights Reserved.
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}

export default Footer
